module.exports = __webpack_public_path__ + "3caa66fddf681d7969a742f51aea0f6a.svg";